import { render, staticRenderFns } from "./ManagedExpenseTable.vue?vue&type=template&id=0b5babc4&scoped=true"
import script from "./ManagedExpenseTable.vue?vue&type=script&lang=ts"
export * from "./ManagedExpenseTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5babc4",
  null
  
)

export default component.exports